import * as Yup from "yup";

export const validateModel = Yup.object().shape({
  socialSecurityNumber: Yup.string()
    .required("Campo obligatorio")
    .max(20, "Campo debe contener menos de 20 caracteres"),
});
